module.exports = __webpack_public_path__ + "img/green_037.393a83f1.png";